import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaTelegram, FaYoutube } from "react-icons/fa";
import logocolor from "../assets/logocolor.svg";

const Footer = () => {
  return (
    <div class="footer_section bg-gray-800 py-8 px-4 mt-8">
      <div class="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between text-white">
        <div class="footer_logo mb-4 md:mb-0 flex flex-col items-center">
          <img
            src={logocolor}
            alt="Rentable Inversor Logo"
            class="w-20 h-20 object-contain"
          />
          <span class="text-white font-bold">Rentable Inversor</span>
        </div>
        <div class="footer_links flex flex-wrap">
          <Link to="/" class="text-gray-300 hover:text-white mr-4 mb-2">
            Inicio
          </Link>
          <Link to="/clases1" class="text-gray-300 hover:text-white mr-4 mb-2">
            Cursos
          </Link>
          <Link
                    to="/"
                    onClick={(event) => {
                      // Guarda el ID de la sección en el almacenamiento local
                      localStorage.setItem("scrollTo", "#resultados");
                      // Desplaza a la sección con el ID especificado
                      const element = document.getElementById("resultados");
                      if (element) {
                        element.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                    class="text-gray-300 hover:text-white mr-4 mb-2"
                  >
                    Resultados
                  </Link>
          <a href="#contacto" class="text-gray-300 hover:text-white mr-4 mb-2">
            Contacto
          </a>
        </div>
        <div class="footer_socials flex items-center">
          <a
            href="https://www.instagram.com/rentableinversor/"
            class="text-gray-300 hover:text-white mr-4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={24} color="white" />
          </a>
          <a
            href="https://t.me/rentableinversor"
            class="text-gray-300 hover:text-white mr-4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTelegram size={24} color="white" />
          </a>
          <a
            href="https://www.youtube.com/@RentableInversor01"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-300 hover:text-white mr-4"
          >
            <FaYoutube size={24} color="white" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
